import { type WalletClient } from 'wagmi'

export function walletClientToSigner(walletClient: WalletClient) {
    const { account, chain, transport } = walletClient;
    return {
        account,
        transport,
        chain
    }
}